import React from "react";
import { Clock } from "lucide-react";
import NoDataFound from "../../../components/common/NoDataFound";
import "../../../components/layout/ModuleLayout.css";

interface SOP {
  id: number;
  name: string;
  role: string;
  description: string;
  frequency: string;
  lastUpdated?: string;
}

interface IdentityProcessesBodyProps {
  sops: SOP[];
}

const IdentityProcessesBody: React.FC<IdentityProcessesBodyProps> = ({
  sops,
}) => {
  return (
    <div className="netbody-card flex flex-col h-full">
      <div className="netbody-content">
        <div className="scroll-container-nofilters flex-1 overflow-hidden">
          {sops.length === 0 ? (
            <NoDataFound
              title="No Processes Found"
              message="No processes have been assigned to you."
            />
          ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {sops.map((sop) => (
                <div
                  key={sop.id}
                  className="p-4 border border-gray-100 hover:border-blue-200 rounded-lg transition-colors group"
                >
                  <div className="flex justify-between items-start mb-2">
                    <h3 className="font-bold text-gray-800">{sop.name}</h3>
                    <span className="text-[10px] uppercase font-bold text-blue-700 bg-blue-50 px-2 py-1 rounded">
                      {sop.role}
                    </span>
                  </div>
                  <p className="text-sm text-gray-600 mb-2">
                    {sop.description}
                  </p>
                  <div className="flex items-center gap-2 text-xs text-gray-400">
                    <Clock className="w-3 h-3" /> Review: {sop.frequency}
                  </div>
                </div>
            ))}
          </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default IdentityProcessesBody;
